const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    GOOGLE_SIGNIN_START: 'GOOGLE_SIGNIN_START',
    GOOGLE_SIGNIN_SUCCESS: 'GOOGLE_SIGNIN_SUCCESS',
    GOOGLE_SIGNIN_FAILURE: 'GOOGLE_SIGNIN_FAILURE',
    
    EMAIL_SIGNIN_START: 'EMAIL_SIGNIN_START',
    EMAIL_SIGNIN_SUCCESS: 'EMAIL_SIGNIN_SUCCESS',
    EMAIL_SIGNIN_FAILURE:'EMAIL_SIGNIN_FAILURE'
}
export default UserActionTypes;